export default __webpack_public_path__ + "static/media/guide18.32d695c8.png";